export default __webpack_public_path__ + "static/media/FP_FM_GR.152d0e10.png";